import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import CollapseHeader from "../../../../core/common/collapse-header/collapse-header";
import CopyRightInfo from "../../../../core/common/copyRightInfo";
import Table from "../../../../core/common/dataTable/index";
import ChatSettingsMenu from "./common/chat-setting-menu";
import DropDown from '../../../../core/common/commonDropDown';
import PreLoader from "../../../../core/common/preLoader";
import useFetch from "../../../../hooks/useFetch";
import { API, MONTHS_OPTS } from "../../../../common/Constants";
import { getAPIHeaders } from "../../../../common/Utils";
import { RoleCredit, ChatTokenUserUsage, TokenAllocationSummary } from "../../../../types/dataModel";
import CommonTabMenu from "../commonTabMenu";



const ChatTokenUsage = () => {
  const routes = all_routes;
  const { isLoading, callFetch } = useFetch();
  const [chatTokenRolesOpts, setChatTokenRolesOpts] = React.useState<any[]>([]);
  const [tokenLimits, setTokenLimits] = React.useState<TokenAllocationSummary>({});
  const [tokenUsage, setTokenUsage] = React.useState<ChatTokenUserUsage[]>([]);
  const [selectedRole, setSelectedRole] = React.useState<any | undefined>(undefined);
  const [selectedMonth, setSelectedMonth] = React.useState<any | undefined>(String(new Date().getMonth() + 1).padStart(2, '0'));
  const [selectedYear, setSelectedYear] = React.useState<any | undefined>(String(new Date().getFullYear()));
  const [roleUserCount, setRoleUserCount] = React.useState<any[]>([]);
  const [roleMonthlyUsage, setRoleMonthlyUsage] = React.useState<number>(0);

  React.useEffect(() => {
    fetchTokenRoleLimits();
    fetchFeatureTokenLimits();
    fetchRoleUserCount();
  }, []);

  React.useEffect(() => {
      if (selectedRole && selectedMonth && selectedYear) {
        fetchTokenUsageHistory();
      }
  }, [selectedRole, selectedMonth, selectedYear]);

  const fetchFeatureTokenLimits = () => {
      callFetch(API.SETTINGS_AI_FEATURE_ALLOCATION.replace(':featureId', 'AI_CA_001'),
        'GET',
        getAPIHeaders(),
        null,
        null
      ).then((res) => {
        setTokenLimits(res)
      }).catch((err) => {});
  }


  const fetchRoleUserCount = () => {
        callFetch(API.AI_FEATURE_USER_COUNT.replace(':featureId', 'AI_CA_001'),
          'GET',
          getAPIHeaders(),
          null,
          null
        ).then((res) => {
          setRoleUserCount(res)
        }).catch((err) => { });
  }
  

  const fetchTokenRoleLimits = () => {
        callFetch(API.SETTINGS_AI_ROLE_LIMITS,
          'GET',
          getAPIHeaders(),
          null,
          null
        ).then((res) => {
          setSelectedRole(res?.AI_CA_001[0]?.roleId);
          setChatTokenRolesOpts(res?.AI_CA_001?.map((role: RoleCredit) => ({
            value: role.roleId,
            label: role.roleName,
            monthlyTokenLimit: role.monthlyTokenLimit
          })));
      
        }).catch((err) => {});
  }

  const fetchTokenUsageHistory= () => {
        callFetch(API.SETTINGS_AI_TOKEN_USAGE.replace(':roleId', selectedRole).replace(':featureId', 'AI_CA_001'), 
          'GET', 
          getAPIHeaders(), 
          { month: selectedMonth, year: selectedYear }
          , null
        ).then((res) => {
          setTokenUsage(res);
          let roleTokenUsed = 0 ;
          res.forEach((user: ChatTokenUserUsage) => {
            roleTokenUsed += user.userTokensUsed;
          });
          setRoleMonthlyUsage(roleTokenUsed);

        }).catch((err) => {});
  }

  const columns = [
    {
      title: "Acct ID",
      dataIndex: "accountId",
      sorter: (a: any, b: any) => a.accountId - b.accountId,
    },
    {
      title: "Username",
      dataIndex: "userName",
      sorter: (a: any, b: any) => a.userName?.localeCompare(b.userName),
      defaultSortOrder: "ascend",
    },
    {
      title: "Name",
      dataIndex: "userFullName",
      sorter: (a: any, b: any) => a.userFullName?.localeCompare(b.userFullName),
    },
    {
      title: "Tokens Used",
      dataIndex: "userTokensUsed",
      sorter: (a: any, b: any) => a.userTokensUsed - b.userTokensUsed,
    },
    {
      title: "Tokens Cost (INR)",
      dataIndex: "userTokensUsedCostInr",
      sorter: (a: any, b: any) => a.userTokensUsedCostInr - b.userTokensUsedCostInr,
    }
  ]


  const renderFilters = () => {
    return (
      <div className="d-flex align-items-center gap-3 flex-wrap">
        <div className="d-flex align-items-center flex-wrap mt-1 justify-content-center gap-2">
          <DropDown
            value={selectedRole}
            options={chatTokenRolesOpts}
            onChange={(val) => {
              setSelectedRole(val);
            }}
            defaultValue={chatTokenRolesOpts?.find((opt) => opt.value === selectedRole)?.value || chatTokenRolesOpts?.[0]?.value}
          />
          <DropDown
            value={selectedMonth}
            options={MONTHS_OPTS}
            onChange={(val) => {
              setSelectedMonth(val);
            }} 
            defaultValue={String(new Date().getMonth() + 1).padStart(2, '0')}
             
            />
            <DropDown
            value={selectedYear}
            options={Array.from({ length: new Date().getFullYear() - 2025 + 1 }, (_, i) => ({
              value: (2025 + i).toString(),
              label: (2025 + i).toString(),
            })).reverse()}
            onChange={(val) => {
              setSelectedYear(val);
            } } 
            defaultValue={String(new Date().getFullYear())}         
          />
        </div>
      </div>
    )
  }

    const renderTokenCalculation = () => {
      return (
        <div className="border rounded p-3">
          {(() => {  
            let userCount = roleUserCount.find((role: any) => role.roleId === selectedRole)?.count || 0;
            let roleTokenLimit = userCount * (chatTokenRolesOpts?.find((opt) => opt.value === selectedRole)?.monthlyTokenLimit || 0);
            return (
              <>
                <h5 className="mb-3">Token Summary</h5>
                <div className="d-flex flex-column">
                  <h6 className="mb-2">Total Tokens: <span className="text-primary">{tokenLimits?.effectiveFeatureMaxLimit || 0}</span> , Topups: <span className="text-secondary">{tokenLimits?.totalTopUps || 0} </span></h6>
                  <h6 className="mb-2">{chatTokenRolesOpts?.find((opt) => opt.value === selectedRole)?.label} Token limit: <span className=" text-muted">{roleTokenLimit}</span> , Tokens Used:<span className="fw-bold text-muted"> {roleMonthlyUsage || 0} </span> </h6>
                </div>
              </>
            );
          })()}
        </div>)
    }

  return (
    <div>
      <>
        <PreLoader showLoader={isLoading} />
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Chat Settings</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Administration</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Settings
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
            {/* /Breadcrumb */}
            <CommonTabMenu activeTab="Chat" />
            <div className="row">
              <div className="col-xl-3 theiaStickySidebar">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex flex-column list-group settings-list">
                     <ChatSettingsMenu activeTab="chatTokenUsage" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-9">
                <div className="card">
                  <div className="card-body">
                    <div className="border-bottom pb-3 justify-content-between d-flex align-items-center">
                      <h4>Chat Token Usage</h4>
                      {renderFilters()}
                    </div>
                    <div className="row align-items-center mt-2">
                      <div className="col-12">
                        {renderTokenCalculation()}
                      </div>
                    </div>
                    <Table dataSource={tokenUsage} columns={columns} Selection={false} refresh={fetchTokenUsageHistory} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
            <CopyRightInfo/>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>

    </div>
  );
};

export default ChatTokenUsage;